import React from "react";
import { useGetPublicContactInfoQuery } from "../redux/api/contactsApiSlice";
import { BeatLoader } from "react-spinners";

const OfficeAddress = () => {
  const { data: contactInfo, isLoading } = useGetPublicContactInfoQuery();
  if (isLoading)
    return (
      <div className="text-center">
        <BeatLoader color="#000" />
      </div>
    );
  return (
    <p
      className="m-0"
      dangerouslySetInnerHTML={{
        __html: contactInfo?.data?.address || "",
      }}
    ></p>
  );
};

export default OfficeAddress;
